import { ActionTree } from 'vuex';
import { ISignState } from './signature.types';

const signActions: ActionTree<ISignState, any> = {
  clearSignature({ commit }): void {
    commit('setSignature', '');
  },
  setSignature({ commit }, signature: string): void {
    commit('setSignature', signature);
  },
};

export default signActions;
